<template>
    <div class="test_wrapper">
        <div class="main_wrapper">
            <div class="content_wrapper">
                <div class="main_content">
                    <div class="screen_title">
                      <img src="@/assets/icons/bobSepticSecondScreenTitle.svg" alt="">
                    </div>
                    <div class="screen_subtitle">
                      <img src="@/assets/icons/bobSepticSecondScreenSubtitle.svg">
                    </div>
                </div>
                <div class="footer_buttons">
                    <div class="first_button" @click="pushToFinalScreen('bs_lead_chicken_button')">
                      I`m chicken
                    </div>
                    <div class="second_button" @click="pushToFinalScreen('bs_lead_handle_button')">
                      I can handle it
                    </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import logAnalyticsEvent from '@/helpers/analytics'

export default {
  name: "bobsSepticEventSecondScreen",
  methods: {
      pushToFinalScreen (analytic) {
          logAnalyticsEvent(analytic)
          window.location.replace(`${location.origin}/r/bslead/final`)
      }

  }
}
</script>

<style scoped>
    .main_wrapper {
        height: 100vh;
        background-repeat: no-repeat;
        background-position: center;
        background-size:cover;
        background-image: url("~@/assets/icons/sec__background.png");
    }
    .screen_title {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-top: 25px;
    }
    .screen_title img{
        max-width: 200px;
    }
    .screen_subtitle img {
        max-width: 300px;
    }
    .screen_subtitle {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .footer_buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 185px;
    }
    .first_button {
      margin-bottom: 23px;
    }
    .first_button, .second_button {
        text-transform: uppercase;
        color: white;
        border: 1px solid white;
        font-family: 'Proxima Nova Light';
        width: 100%;
        padding-top: 5px;
        padding-bottom: 5px;
        max-width: 190px;
        text-align: center;
        cursor: pointer;
        font-size: 19px;
    }
    .content_wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }
    @media screen and (min-height: 800px) {
        .screen_subtitle img {
            margin-top: 50px !important;
        }
        .screen_title img {
            margin-top: 45px;
        }
        .footer_buttons {
            /*margin-bottom: 185px;*/
        }
    }
    @media screen and (max-height: 916px) {
        .footer_buttons {
            margin-bottom: 108px;
        }
    }

</style>